/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyServiceAccountDetails {
    getFixupPrototypeFunction() { return PolicyServiceAccountDetails.fixupPrototype; }

    static newInstance(model: Partial<PolicyServiceAccountDetails>): PolicyServiceAccountDetails {
        let obj = Object.assign(new PolicyServiceAccountDetails(), model);
        PolicyServiceAccountDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyServiceAccountDetails>): PolicyServiceAccountDetails {
        if (!model) return null;
        return PolicyServiceAccountDetails.newInstance(<PolicyServiceAccountDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyServiceAccountDetails) {
        if (!obj) return;

        models.PolicyServiceAccountDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyServiceAccountDetails): boolean {
        Object.setPrototypeOf(obj, PolicyServiceAccountDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * The cloud name of the account for which the policywill be executed ex: AWS, Azure, GCP, OCI etc
     */
    cloud: string;

    /**
     * Identifier of the cloud account on boarded in the on boarding section
     */
    cloud_account_id: string;

    /**
     * The region of the service account where it needs to be executed, if this is not provided the policy will execute for all the region
     */
    region: string;

    /**
     * Resource group for which you need to execute the policy for, this is not a mandatory parameter to be passed
     */
    resourcegroup: string;

}
